'use client'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'
import { useAuthStore } from '@/store/authStore'
import { getRoleDefaultPage } from '@/lib/role-navigation'
import type { Role } from '@/api/auth'

export default function Home() {
  const router = useRouter()
  const tokenPayload = useAuthStore(state => state.token_payload)
  const getRole = useAuthStore(state => state.getRole)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    // VAPT #15: hydrate identity from the cookie-authenticated /me endpoint
    // (was localStorage). `checked` gates the redirect so we don't bounce to
    // sign-in before hydration resolves.
    let cancelled = false
    useAuthStore.getState().hydrateFromMe().finally(() => {
      if (!cancelled) setChecked(true)
    })
    return () => {
      cancelled = true
    }
  }, []) // Run only once on mount

  useEffect(() => {
    if (!checked) return
    const handleRedirect = () => {
      // Check if user is authenticated
      if (tokenPayload) {
        // Get current role (respecting dev override in development)
        const getCurrentRole = (): Role => {
          // In development, allow role override for testing
          if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
            const devRoleOverride = localStorage.getItem('dev_role_override');
            if (devRoleOverride && ['admin', 'property_manager', 'company_admin', 'utility_admin', 'account_payables', 'account_receivables', 'home_owner', 'tenant', 'resident', 'esg'].includes(devRoleOverride)) {
              return devRoleOverride as Role;
            }
          }
          
          // Default to JWT role from auth store
          return getRole();
        }

        const currentRole = getCurrentRole()
        const defaultPage = getRoleDefaultPage(currentRole)
        
        router.replace(defaultPage)
      } else {
        // User is not authenticated, redirect to sign-in
        router.replace('/sign-in')
      }
    }
    
    // Redirect once hydration has resolved.
    handleRedirect()
  }, [checked, router, tokenPayload, getRole])

  // Show loading state while determining redirect
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-2"></div>
        <p>Loading...</p>
      </div>
    </div>
  )
}

